import {
  createContext,
} from "react";

const LocalStorageContext = createContext({});

export default LocalStorageContext;
